/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ManufacturerInputs */

const en_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manufacturer`)
};

const es_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabricante`)
};

const fr_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabricant`)
};

const de_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hersteller`)
};

const ja_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製造元`)
};

const zh_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制造商`)
};

const ar_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشركة المصنعة`)
};

const id_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabrikan`)
};

const it_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruttore`)
};

const ru_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производитель`)
};

const pt_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabricante`)
};

const ko_field_manufacturer = /** @type {(inputs: Field_ManufacturerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제조사`)
};

/**
* | output |
* | --- |
* | "Manufacturer" |
*
* @param {Field_ManufacturerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_manufacturer = /** @type {((inputs?: Field_ManufacturerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ManufacturerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_manufacturer(inputs)
	if (locale === "es") return es_field_manufacturer(inputs)
	if (locale === "fr") return fr_field_manufacturer(inputs)
	if (locale === "de") return de_field_manufacturer(inputs)
	if (locale === "ja") return ja_field_manufacturer(inputs)
	if (locale === "zh") return zh_field_manufacturer(inputs)
	if (locale === "ar") return ar_field_manufacturer(inputs)
	if (locale === "id") return id_field_manufacturer(inputs)
	if (locale === "it") return it_field_manufacturer(inputs)
	if (locale === "ru") return ru_field_manufacturer(inputs)
	if (locale === "pt") return pt_field_manufacturer(inputs)
	return ko_field_manufacturer(inputs)
});